/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseError } from './BaseError';
const FirstPhaseLTILaunchExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'originalException',
        /* #__PURE__ */ parsers.maybeNull(BaseError),
        'original_exception',
    ],
]), BaseError);
export class FirstPhaseLTILaunchException extends BaseError {
    static decode(input) {
        return FirstPhaseLTILaunchExceptionParser.decode(input).map(res => new FirstPhaseLTILaunchException(res));
    }
    static unsafeDecode(input) {
        return FirstPhaseLTILaunchException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FirstPhaseLTILaunchExceptionParser.encode(data);
    }
    static schema() {
        return FirstPhaseLTILaunchExceptionParser.schema();
    }
}
